import Amentities from './Amenities'

export default Amentities